module.exports = __webpack_public_path__ + "static/media/fishGrill.cffdffd7.png";